import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { mediaUrl } from '@bluheadless/ui-logic/src/assets'
import { cx } from '@emotion/css'
import { array, string } from 'prop-types'
import { useEffect, useState } from 'react'
import MainSlider from '../../../organisms/main-slider'
import Image from '../../../particles/image'
import { Slide } from '../../../particles/slider'
import { PhotoDescription, Root } from './store-locator-details.styled'

const StoreLocatorDetailsGallery = ({ className, title, image, images }) => {
	const [storeImages, setStoreImages] = useState([])
	const { siteName } = useConfig()

	useEffect(() => {
		if (images?.length) {
			const storeImages = images.map((image) => {
				let storeImage = { ...image }
				storeImage.url = mediaUrl(image.image)
				return storeImage
			})
			setStoreImages(storeImages)
		}
	}, [images])

	return storeImages?.length > 1 || image ? (
		<Root className={cx('StoreLocatorDetailsGallery-root', className)}>
			{storeImages?.length > 1 ? (
				<MainSlider navigation={false}>
					{storeImages.map(({ id, description, url }) => (
						<Slide key={id}>
							<Image src={url} alt={title ? title + ' | ' + siteName : siteName} />
							{description && (
								<PhotoDescription component="span" variant="body1" color="primary.contrastText">
									{description}
								</PhotoDescription>
							)}
						</Slide>
					))}
				</MainSlider>
			) : image ? (
				<Image src={mediaUrl(image)} alt={title ? title + ' | ' + siteName : siteName} />
			) : null}
		</Root>
	) : null
}

StoreLocatorDetailsGallery.defaultProps = {}
StoreLocatorDetailsGallery.propTypes = {
	/**
	 * Defines className for root node.
	 */
	className: string,
	/**
	 * Image of the store.
	 */
	image: string,
	/**
	 * Array of images of the store.
	 */
	images: array,
}

export default StoreLocatorDetailsGallery
